import { render } from "./sales-header.vue?vue&type=template&id=7df64e63"
import script from "./sales-header.vue?vue&type=script&lang=js"
export * from "./sales-header.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__